import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FilterGroupLogsDialogData {
  logs: string | null;
  name: string;
  derivedFieldName: string;
}

@Component({
  selector: 'app-filter-group-logs-dialog',
  templateUrl: './filter-group-logs-dialog.component.html',
  standalone: false
})
export class FilterGroupLogsDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FilterGroupLogsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FilterGroupLogsDialogData
  ) {}
}
